import { render } from "./ErrorText.vue?vue&type=template&id=41a707a5&scoped=true"
import script from "./ErrorText.vue?vue&type=script&lang=js"
export * from "./ErrorText.vue?vue&type=script&lang=js"

import "./ErrorText.vue?vue&type=style&index=0&id=41a707a5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a707a5"]])

export default __exports__